import { request } from "@/request/http";

export default {
  getPreviewQuestionBank: (data) => {
    return request("GET", `/index.php/backquestionbank/getPreviewQuestionBank`, data);
  },

};